export default __webpack_public_path__ + "static/media/10.0ca8b70b.png";